<template>
  <h1>mobile inquiry</h1>
</template>

<script>
export default {
  name: 'MobileInquiryResult',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    widget: Object,
  },
}
</script>

<style scoped>

</style>
